import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '../utils/propStyles';
import { AccessibilityStore, DataStore } from '../stores';
import { ChartStore } from '../stores';
import ChartPeriodSelectorButton from './ChartPeriodSelectorButton';

const ChartPeriodSelectorWrapper = styled<any, any>('div')`
    ${propStyles};
`;

ChartPeriodSelectorWrapper.defaultProps = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: ['center', 'flex-start'],
    marginY: 'sm',
};
interface ChartPeriodSelectorProps {
    theme?: any;
    accessibilityStore?: AccessibilityStore;
    dataStore?: DataStore;
    chartStore?: ChartStore;
}
@observer
export class ChartPeriodSelector extends Component<ChartPeriodSelectorProps> {
    constructor(props: ChartPeriodSelectorProps) {
        super(props);
    }

    render() {
        const { theme, chartStore } = this.props;

        if (!chartStore) {
            return null;
        }
        const { periodSelector } = chartStore;
        const { noDataForPeriodUi, options } = periodSelector;
        return (
            <ChartPeriodSelectorWrapper {...theme.ChartPeriodSelectorWrapper}>
                {options.map(option => {
                    return (
                        <ChartPeriodSelectorButton
                            key={option.label}
                            chartStore={chartStore}
                            option={option}
                            noDataForPeriodUi={noDataForPeriodUi}
                        />
                    );
                })}
            </ChartPeriodSelectorWrapper>
        );
    }
}

export default withTheme(ChartPeriodSelector);



// WEBPACK FOOTER //
// ./src/Components/ChartPeriodSelector.tsx